import {CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IngresoComponent } from './shared/autenticacion/ingreso.component';
import { DashboardComponent } from './shared/dashboard/dashboard.component';
import { RecuperacionDatosComponent } from './shared/autenticacion/recuperacion-datos.component';
import { PreloadingPersonalizado } from './_preloading/preloading-personalizado';

// Pagina de Errores
import { UnicaSesionComponent } from './shared/error/unicaSesion.component';
import { SinAutorizacionComponent } from './shared/error/sinAutorizacion.component';
import { PaginaNoEncontradaComponent } from './shared/error/paginaNoEncontrada.component';
import { AuthGuard } from './_guards/auth.guard';


const routes: Routes = [
  { path: '', redirectTo: '/ingreso', pathMatch: 'full' },
  { path: 'ingreso', component: IngresoComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [ AuthGuard ] },
  { path: 'dashboard/responsabilidad/:mosMensaje', component: DashboardComponent, canActivate: [ AuthGuard ] },
  { path: 'password-recovery/:time/:token', component: RecuperacionDatosComponent },
  { path: 'asi', loadChildren: () => import('./ASI/asi.module').then(m => m.AsiModule), data: { preload: false } },
  { path: 'ter', loadChildren: () => import('./TER/ter.module').then(m => m.TerModule), data: { preload: false } },
  { path: 'apl', loadChildren: () => import('./APL/apl.module').then(m => m.AplModule), data: { preload: false } },
  { path: 'dor', loadChildren: () => import('./DOR/dor.module').then(m => m.DorModule), data: { preload: false } },
  { path: 'gcc', loadChildren: () => import('./GCC/gcc.module').then(m => m.GccModule), data: { preload: false } },
  { path: 'sol', loadChildren: () => import('./SOL/sol.module').then(m => m.SolModule), data: { preload: false } },
  { path: 'pys', loadChildren: () => import('./PYS/pys.module').then(m => m.PysModule), data: { preload: true } },
  { path: 'gen', loadChildren: () => import('./GEN/gen.module').then(m => m.GenModule), data: { preload: false } },
  { path: 'ceu', loadChildren: () => import('./CEU/ceu.module').then(m => m.CeuModule), data: { preload: false } },
  { path: 'rad', loadChildren: () => import('./RAD/rad.module').then(m => m.RadModule), data: { preload: false } },
  { path: 'com', loadChildren: () => import('./COM/com.module').then(m => m.ComModule), data: { preload: false } },
  { path: 'des', loadChildren: () => import('./DES/des.module').then(m => m.DesModule), data: { preload: false } },
  { path: 'log', loadChildren: () => import('./LOG/log.module').then(m => m.LogModule), data: { preload: false } },
  { path: 'rep', loadChildren: () => import('./REP/rep.module').then(m => m.RepModule), data: { preload: false } },
  { path: 'crd', loadChildren: () => import('./CRD/crd.module').then(m => m.CrdModule), data: { preload: false } },

  // error Unica Sesión
  { path: 'unica-sesion', component: UnicaSesionComponent },
  // error 401 - Sin Autororización
  { path: 'sin-autorizacion', component: SinAutorizacionComponent },
  // error 404 - Página no Encontrada
  { path: '**', component: PaginaNoEncontradaComponent }

];

@NgModule( {
  imports: [ RouterModule.forRoot( routes, { preloadingStrategy: PreloadingPersonalizado } ) ],
  providers: [ PreloadingPersonalizado ],
  exports: [ RouterModule ]
} )

export class AppRoutingModule {

}
